import styled, { css } from 'styled-components';

const MapPinImage = styled.svg`
  height: 42px;
  width: 30px;
  ${(props) =>
    props.offsetAnchor &&
    css`
      transform: translate(-50%, -100%);
    `}
`;

const Slash = styled.path`
  fill: var(--neutral-200);
  stroke: var(--neutral-200);
  stroke-linecap: round;
  stroke-width: 28px;
  stroke-linejoin: round;
  opacity: 1;
`;
MapPinImage.Slash = Slash;

export default MapPinImage;
